/**
 * @generated SignedSource<<7109954712dbbd83ea04c9edec7380c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentNotificationEmailCtaButton = "disabled" | "enabled" | "%future added value";
export type ContentSystemTaskKind = "add_events_to_calendar" | "calendar_connection" | "community_agreement" | "complete_profile" | "connect_slack" | "custom_profile_field" | "default_profile_fields" | "download_mobile_app" | "onboarding_complete" | "onboarding_module" | "onboarding_welcome" | "slack_connection" | "slack_invite" | "%future added value";
export type ContentType = "assignment" | "assignment_submission" | "attachment" | "comment" | "confirmation" | "custom" | "embed" | "module" | "occurrence" | "post" | "quiz" | "survey" | "text" | "video" | "%future added value";
export type ContentUsageEntity = "collection" | "content" | "content_usage_confirmation" | "curriculum" | "dashboard_block_content" | "member_onboarding" | "organization" | "product_app" | "%future added value";
export type ContentUsageStatus = "draft" | "published" | "%future added value";
export type ContentUsageSubmissionMethod = "mark_as_complete" | "submission" | "%future added value";
export type ContentUsageSubmissionVisibility = "cohort" | "member_group" | "private" | "%future added value";
export type MessageTemplateKind = "community_welcome" | "course_welcome" | "custom" | "product_completion" | "%future added value";
export type WebFormQuestionType = "link" | "multiple_select" | "ranking" | "rating" | "single_select" | "written_answer" | "%future added value";
export type UpdateContentUsageInput = {
  botResponseIds?: ReadonlyArray<string> | null;
  content?: EditContentInput | null;
  contentId?: string | null;
  contentSystemTaskKind?: ContentSystemTaskKind | null;
  contentType?: ContentType | null;
  contentUsageId?: string | null;
  contentUsageInput?: ContentUsageInput | null;
  detachFromContent?: boolean | null;
  enableChildDefaultTimeEstimate?: boolean | null;
  organizationId: string;
  productId?: string | null;
  timeEstimateMinutes?: number | null;
};
export type ContentUsageInput = {
  confirmationModalInput?: EditContentInput | null;
  dueAt?: string | null;
  dueDateUpdatedEmailMessageInput?: MessageTemplateInput | null;
  entity?: ContentUsageEntity | null;
  entityId?: string | null;
  occurrences?: ReadonlyArray<string> | null;
  ordering?: number | null;
  passPercentage?: number | null;
  prerequisiteIds?: ReadonlyArray<string> | null;
  releasedAt?: string | null;
  requireScormCompletion?: boolean | null;
  showComments?: boolean | null;
  status?: ContentUsageStatus | null;
  submissionFormat?: AssignmentSubmissionFormatInput | null;
  submissionMethod?: ContentUsageSubmissionMethod | null;
  submissionVisibility?: ContentUsageSubmissionVisibility | null;
};
export type MessageTemplateInput = {
  chatContent?: ChatContentInput | null;
  emailContent?: EmailContentInput | null;
  id?: string | null;
  kind?: MessageTemplateKind | null;
  name: string;
  slackContent?: SlackContentInput | null;
};
export type EmailContentInput = {
  bccEmails?: ReadonlyArray<string> | null;
  bccUserIds?: ReadonlyArray<string> | null;
  ccEmails?: ReadonlyArray<string> | null;
  ccUserIds?: ReadonlyArray<string> | null;
  richBody: string;
  send: boolean;
  subject: string;
};
export type SlackContentInput = {
  richBody: string;
  send: boolean;
  sendAs?: string | null;
};
export type ChatContentInput = {
  richBody: string;
  send: boolean;
  sendAs?: string | null;
};
export type AssignmentSubmissionFormatInput = {
  file: AssignmentSubmissionFormatSettingsInput;
  link: AssignmentSubmissionFormatSettingsInput;
  text: AssignmentSubmissionFormatSettingsInput;
};
export type AssignmentSubmissionFormatSettingsInput = {
  enabled: boolean;
  required: boolean;
};
export type EditContentInput = {
  attachments?: ReadonlyArray<ContentAttachmentInput> | null;
  contentLabelId?: string | null;
  coverAudio?: string | null;
  coverAudioAssetId?: string | null;
  coverPhoto?: string | null;
  coverPhotoAssetId?: string | null;
  coverVideo?: string | null;
  coverVideoAssetId?: string | null;
  coverVideoDurationSeconds?: number | null;
  ctaAppId?: string | null;
  ctaText?: string | null;
  description?: string | null;
  isAiGenerated?: boolean | null;
  name?: string | null;
  notificationEmailCtaButton?: ContentNotificationEmailCtaButton | null;
  notificationEmailSubject?: string | null;
  releaseDatetime?: string | null;
  releaseNow?: boolean | null;
  richEditorDescriptionContent?: string | null;
  richEditorNotificationEmailBodyContent?: string | null;
  sendNotificationEmail?: boolean | null;
  showComments?: boolean | null;
  showCoverPlayIcon?: boolean | null;
  submissionLink?: string | null;
  thumbnailAssetId?: string | null;
  thumbnailUrl?: string | null;
  timeEstimateMinutes?: number | null;
  webFormRevision?: CreateWebFormRevisionInput | null;
};
export type ContentAttachmentInput = {
  id?: string | null;
  mediaAssetId?: string | null;
  mediaUrl?: string | null;
  name?: string | null;
};
export type CreateWebFormRevisionInput = {
  contentUsageId?: string | null;
  questions: ReadonlyArray<WebFormQuestionInput>;
  webFormId: string;
};
export type WebFormQuestionInput = {
  answerKey?: WebFormQuestionAnswerKeyInput | null;
  isRequired?: boolean | null;
  options?: ReadonlyArray<WebFormQuestionOptionInput> | null;
  richEditorBody: string;
  type: WebFormQuestionType;
};
export type WebFormQuestionOptionInput = {
  id: string;
  label: string;
};
export type WebFormQuestionAnswerKeyInput = {
  correctIds: ReadonlyArray<string>;
  feedback?: string | null;
};
export type InlineContentDrawerTemplate_UpdateContentUsageMutation$variables = {
  contentLabelIds?: ReadonlyArray<string> | null;
  input: UpdateContentUsageInput;
};
export type InlineContentDrawerTemplate_UpdateContentUsageMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly content: {
        readonly contentLabelId: string | null;
        readonly coverPhotoAsset: {
          readonly id: string;
        } | null;
        readonly coverVideoAsset: {
          readonly id: string;
        } | null;
        readonly id: string;
        readonly label: string;
        readonly organization: {
          readonly contentLabels: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly defaultContentTypes: string;
                readonly id: string;
                readonly label: string;
                readonly updatedAt: string;
              };
            }>;
          };
        };
        readonly systemTaskKind: ContentSystemTaskKind | null;
        readonly type: ContentType;
      };
      readonly contentCoverVideoAssetUsage: {
        readonly id: string;
      } | null;
      readonly contentCoverVideoAssetUsageAverageCompletion: number | null;
      readonly contentCoverVideoAssetUsagePlays: number | null;
      readonly id: string;
      readonly module: {
        readonly children: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly " $fragmentSpreads": FragmentRefs<"DeleteContentUsageButtonFragment">;
            };
          }>;
        } | null;
        readonly id: string;
        readonly type: ContentType;
        readonly usages: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly " $fragmentSpreads": FragmentRefs<"ContentModuleUtils_RefreshContentModulesFragment">;
            };
          }>;
        };
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"ContentUsageGridItemFragment" | "InlineContentDrawerTemplateFragment">;
    } | null;
  };
};
export type InlineContentDrawerTemplate_UpdateContentUsageMutation = {
  response: InlineContentDrawerTemplate_UpdateContentUsageMutation$data;
  variables: InlineContentDrawerTemplate_UpdateContentUsageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentLabelIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetUsage",
  "kind": "LinkedField",
  "name": "contentCoverVideoAssetUsage",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentCoverVideoAssetUsagePlays",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentCoverVideoAssetUsageAverageCompletion",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "systemTaskKind",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentLabelId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "coverPhotoAsset",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "coverVideoAsset",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentLabelNodeConnection",
  "kind": "LinkedField",
  "name": "contentLabels",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentLabelNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentLabel",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v9/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "defaultContentTypes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = [
  {
    "kind": "Variable",
    "name": "contentLabelIds",
    "variableName": "contentLabelIds"
  }
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "richEditorDescriptionContent",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverPhoto",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverVideo",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeEstimateMinutes",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showCoverPlayIcon",
  "storageKey": null
},
v25 = [
  (v19/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordering",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v29 = [
  (v3/*: any*/),
  (v17/*: any*/)
],
v30 = [
  (v17/*: any*/),
  (v3/*: any*/)
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showComments",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasViewerBookmarked",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCurriculumModule",
  "storageKey": null
},
v34 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ContentUsageNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ContentUsage",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v35 = {
  "alias": "allChildren",
  "args": null,
  "concreteType": "ContentUsageNodeConnection",
  "kind": "LinkedField",
  "name": "children",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentLikeNodeConnection",
  "kind": "LinkedField",
  "name": "likes",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalComments",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasViewerCommented",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releasedAt",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerHasCompleted",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLocked",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPrerequisites",
  "storageKey": null
},
v45 = {
  "alias": "createCurriculumModuleItemContentUsageButtonChildren",
  "args": null,
  "concreteType": "ContentUsageNodeConnection",
  "kind": "LinkedField",
  "name": "children",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": (v30/*: any*/),
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v48 = [
  (v47/*: any*/)
],
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v50 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v47/*: any*/),
  (v49/*: any*/)
],
v51 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v47/*: any*/),
  (v49/*: any*/)
],
v52 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v48/*: any*/),
      "type": "Organization",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nonNullProductId",
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v47/*: any*/),
        (v49/*: any*/)
      ],
      "type": "Product",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v50/*: any*/),
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v51/*: any*/),
      "type": "Comment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v51/*: any*/),
      "type": "Feed",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v51/*: any*/),
      "type": "Post",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nullableProductIdString",
          "args": null,
          "kind": "ScalarField",
          "name": "productId",
          "storageKey": null
        },
        (v47/*: any*/),
        (v49/*: any*/)
      ],
      "type": "ContentUsage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v51/*: any*/),
      "type": "ChatChannel",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v51/*: any*/),
      "type": "Dashboard",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v50/*: any*/),
      "type": "AssignmentSubmission",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v48/*: any*/),
      "type": "PathwayGroup",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v48/*: any*/),
      "type": "BrainSearch",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "OccurrenceNodeEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Occurrence",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v17/*: any*/),
        (v21/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isComplete",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "datetimeRange",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Product",
          "kind": "LinkedField",
          "name": "product",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cover",
              "storageKey": null
            },
            (v17/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "event",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Product",
              "kind": "LinkedField",
              "name": "product",
              "plural": false,
              "selections": [
                (v8/*: any*/),
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MemberGroupNodeConnection",
              "kind": "LinkedField",
              "name": "memberGroups",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MemberGroupNodeEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MemberGroup",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v3/*: any*/),
                        (v27/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "parentMemberGroupId",
                          "storageKey": null
                        },
                        (v17/*: any*/),
                        (v46/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "color",
                          "storageKey": null
                        },
                        (v28/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isSystem",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v19/*: any*/)
              ],
              "storageKey": null
            },
            (v52/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OccurrenceRSVPNodeConnection",
          "kind": "LinkedField",
          "name": "rsvps",
          "plural": false,
          "selections": (v25/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserNodeConnection",
          "kind": "LinkedField",
          "name": "attendees",
          "plural": false,
          "selections": (v25/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entity",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creationDatetime",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueAt",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCollectionModule",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "passPercentage",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentUsageNodeConnection",
  "kind": "LinkedField",
  "name": "dependents",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsageNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsage",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Content",
              "kind": "LinkedField",
              "name": "content",
              "plural": false,
              "selections": [
                (v33/*: any*/),
                (v3/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                (v17/*: any*/),
                (v56/*: any*/),
                (v22/*: any*/),
                (v20/*: any*/),
                (v24/*: any*/),
                (v36/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ContentUsageNodeConnection",
                  "kind": "LinkedField",
                  "name": "children",
                  "plural": false,
                  "selections": [
                    (v19/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ContentUsageNodeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ContentUsage",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            (v42/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Content",
                              "kind": "LinkedField",
                              "name": "content",
                              "plural": false,
                              "selections": [
                                (v8/*: any*/),
                                (v11/*: any*/),
                                (v3/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v41/*: any*/),
            (v42/*: any*/),
            (v57/*: any*/),
            (v54/*: any*/),
            (v46/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Content",
              "kind": "LinkedField",
              "name": "module",
              "plural": false,
              "selections": [
                (v33/*: any*/),
                (v58/*: any*/),
                (v17/*: any*/),
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            (v43/*: any*/),
            (v59/*: any*/),
            (v55/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "module",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsageNodeConnection",
      "kind": "LinkedField",
      "name": "children",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentUsage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Content",
                  "kind": "LinkedField",
                  "name": "content",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    (v8/*: any*/),
                    (v17/*: any*/),
                    (v10/*: any*/),
                    (v9/*: any*/),
                    (v56/*: any*/),
                    (v22/*: any*/),
                    (v20/*: any*/),
                    (v24/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v58/*: any*/)
  ],
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAppTitle",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductApp",
  "kind": "LinkedField",
  "name": "productApp",
  "plural": false,
  "selections": [
    (v62/*: any*/),
    (v3/*: any*/),
    (v27/*: any*/)
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationId",
  "storageKey": null
},
v65 = [
  (v62/*: any*/),
  (v3/*: any*/)
],
v66 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "enabled",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "required",
    "storageKey": null
  }
],
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "InlineContentDrawerTemplate_UpdateContentUsageMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v2/*: any*/),
        "concreteType": "UpdateContentUsageResponse",
        "kind": "LinkedField",
        "name": "updateContentUsage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentUsage",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "module",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "usages",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "args": (v15/*: any*/),
                                "kind": "FragmentSpread",
                                "name": "ContentModuleUtils_RefreshContentModulesFragment"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "DeleteContentUsageButtonFragment"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "InlineContentDrawerTemplateFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ContentUsageGridItemFragment"
              }
            ],
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "InlineContentDrawerTemplate_UpdateContentUsageMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v2/*: any*/),
        "concreteType": "UpdateContentUsageResponse",
        "kind": "LinkedField",
        "name": "updateContentUsage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentUsage",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentAttachmentNodeConnection",
                    "kind": "LinkedField",
                    "name": "attachments",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentAttachmentNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentAttachment",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mediaUrl",
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "downloadUrl",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "videoUrl",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "coverVideoDurationSeconds",
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "usages",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WebForm",
                    "kind": "LinkedField",
                    "name": "webForm",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WebFormRevision",
                        "kind": "LinkedField",
                        "name": "currentRevision",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "webFormId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WebFormQuestionNodeConnection",
                            "kind": "LinkedField",
                            "name": "questions",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WebFormQuestionNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WebFormQuestion",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v8/*: any*/),
                                      (v26/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "richEditorBody",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isRequired",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "WebFormQuestionOption",
                                        "kind": "LinkedField",
                                        "name": "options",
                                        "plural": true,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v9/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "WebFormQuestionAnswerKey",
                                        "kind": "LinkedField",
                                        "name": "answerKey",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "correctIds",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "feedback",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssetUsage",
                    "kind": "LinkedField",
                    "name": "coverVideoAssetUsage",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "asset",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "muxAssetPlaybackId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "aspectRatio",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "videoDuration",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentMentionNodeConnection",
                    "kind": "LinkedField",
                    "name": "mentions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentMentionNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentMention",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "fullName",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberGroup",
                                "kind": "LinkedField",
                                "name": "memberGroup",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v17/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "mentionedProduct",
                                "plural": false,
                                "selections": (v29/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentUsage",
                                "kind": "LinkedField",
                                "name": "mentionedContentUsage",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": (v29/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Occurrence",
                                "kind": "LinkedField",
                                "name": "mentionedOccurrence",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v17/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": (v30/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__id",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "module",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "usages",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Curriculum",
                                "kind": "LinkedField",
                                "name": "curriculum",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsageNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "modules",
                                    "plural": false,
                                    "selections": [
                                      (v19/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsageNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentUsage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v3/*: any*/),
                                              (v26/*: any*/),
                                              (v41/*: any*/),
                                              (v42/*: any*/),
                                              (v43/*: any*/),
                                              (v44/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Content",
                                                "kind": "LinkedField",
                                                "name": "content",
                                                "plural": false,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  (v8/*: any*/),
                                                  (v17/*: any*/),
                                                  (v36/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": (v15/*: any*/),
                                                    "concreteType": "ContentUsageNodeConnection",
                                                    "kind": "LinkedField",
                                                    "name": "children",
                                                    "plural": false,
                                                    "selections": [
                                                      (v19/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ContentUsageNodeEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ContentUsage",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v3/*: any*/),
                                                              (v43/*: any*/),
                                                              (v44/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Content",
                                                                "kind": "LinkedField",
                                                                "name": "content",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v23/*: any*/),
                                                                  (v3/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ContentCompletionNodeConnection",
                                                    "kind": "LinkedField",
                                                    "name": "viewerChildContentCompletions",
                                                    "plural": false,
                                                    "selections": (v25/*: any*/),
                                                    "storageKey": null
                                                  },
                                                  (v45/*: any*/),
                                                  (v9/*: any*/),
                                                  (v33/*: any*/),
                                                  (v35/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "OccurrenceNodeConnection",
                                                "kind": "LinkedField",
                                                "name": "occurrences",
                                                "plural": false,
                                                "selections": [
                                                  (v19/*: any*/),
                                                  (v53/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v54/*: any*/),
                                              (v37/*: any*/),
                                              (v55/*: any*/),
                                              (v60/*: any*/),
                                              (v61/*: any*/),
                                              (v63/*: any*/),
                                              (v64/*: any*/),
                                              (v52/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v46/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Collection",
                                "kind": "LinkedField",
                                "name": "collection",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsageNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "modules",
                                    "plural": false,
                                    "selections": [
                                      (v19/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsageNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentUsage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v3/*: any*/),
                                              (v26/*: any*/),
                                              (v54/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isDefaultCollectionModule",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Content",
                                                "kind": "LinkedField",
                                                "name": "content",
                                                "plural": false,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  (v8/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ContentUsageNodeConnection",
                                                    "kind": "LinkedField",
                                                    "name": "children",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ContentUsageNodeEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ContentUsage",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v3/*: any*/),
                                                              (v42/*: any*/),
                                                              (v54/*: any*/),
                                                              (v43/*: any*/),
                                                              (v44/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Content",
                                                                "kind": "LinkedField",
                                                                "name": "confirmationModalContent",
                                                                "plural": false,
                                                                "selections": (v4/*: any*/),
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Content",
                                                                "kind": "LinkedField",
                                                                "name": "content",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v3/*: any*/),
                                                                  (v17/*: any*/),
                                                                  (v8/*: any*/),
                                                                  (v9/*: any*/),
                                                                  (v10/*: any*/),
                                                                  (v24/*: any*/),
                                                                  (v22/*: any*/),
                                                                  (v20/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Product",
                                                                "kind": "LinkedField",
                                                                "name": "product",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "SlackProductConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "slack",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v3/*: any*/),
                                                                      {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "inviteURL",
                                                                        "storageKey": null
                                                                      }
                                                                    ],
                                                                    "storageKey": null
                                                                  },
                                                                  (v3/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              (v55/*: any*/),
                                                              (v52/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v17/*: any*/),
                                                  (v45/*: any*/),
                                                  (v9/*: any*/),
                                                  (v33/*: any*/),
                                                  (v35/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v37/*: any*/),
                                              (v55/*: any*/),
                                              (v43/*: any*/),
                                              (v60/*: any*/),
                                              (v61/*: any*/),
                                              (v63/*: any*/),
                                              (v64/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "OccurrenceNodeConnection",
                                                "kind": "LinkedField",
                                                "name": "occurrences",
                                                "plural": false,
                                                "selections": [
                                                  (v53/*: any*/),
                                                  (v19/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v52/*: any*/),
                                              (v41/*: any*/),
                                              (v44/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductApp",
                                    "kind": "LinkedField",
                                    "name": "app",
                                    "plural": false,
                                    "selections": (v65/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v41/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isReleased",
                                "storageKey": null
                              },
                              (v43/*: any*/),
                              (v44/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Content",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v17/*: any*/),
                                  (v33/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsageNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": false,
                                    "selections": (v25/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductApp",
                                "kind": "LinkedField",
                                "name": "productApp",
                                "plural": false,
                                "selections": (v65/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v43/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v37/*: any*/),
                              (v60/*: any*/),
                              (v61/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Content",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v33/*: any*/),
                                  (v35/*: any*/),
                                  (v3/*: any*/),
                                  (v17/*: any*/),
                                  (v10/*: any*/),
                                  (v56/*: any*/),
                                  (v22/*: any*/),
                                  (v20/*: any*/),
                                  (v24/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v63/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  (v33/*: any*/),
                  (v58/*: any*/)
                ],
                "storageKey": null
              },
              (v43/*: any*/),
              (v44/*: any*/),
              (v54/*: any*/),
              (v55/*: any*/),
              (v26/*: any*/),
              (v57/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "submissionMethod",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "submissionVisibility",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AssignmentSubmissionFormat",
                "kind": "LinkedField",
                "name": "submissionFormat",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssignmentSubmissionFormatSettings",
                    "kind": "LinkedField",
                    "name": "text",
                    "plural": false,
                    "selections": (v66/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssignmentSubmissionFormatSettings",
                    "kind": "LinkedField",
                    "name": "file",
                    "plural": false,
                    "selections": (v66/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssignmentSubmissionFormatSettings",
                    "kind": "LinkedField",
                    "name": "link",
                    "plural": false,
                    "selections": (v66/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v31/*: any*/),
              (v59/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requireScormCompletion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentUsageNodeConnection",
                "kind": "LinkedField",
                "name": "prerequisites",
                "plural": false,
                "selections": (v34/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "adminCanLearnMode",
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  (v67/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductMembership",
                    "kind": "LinkedField",
                    "name": "viewerMembership",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductApp",
                "kind": "LinkedField",
                "name": "productApp",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v27/*: any*/),
                  (v62/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentDashboardBlock",
                "kind": "LinkedField",
                "name": "contentDashboardBlock",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "confirmationModalContent",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ctaText",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v37/*: any*/),
              (v60/*: any*/),
              (v52/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contentId",
                "storageKey": null
              },
              (v32/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v42/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ScormCompletion",
                "kind": "LinkedField",
                "name": "viewerScormCompletion",
                "plural": false,
                "selections": [
                  (v67/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AssignmentSubmission",
                "kind": "LinkedField",
                "name": "viewerSubmission",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPassed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "df9f24e23b85f260dd752dad4f87e04d",
    "id": null,
    "metadata": {},
    "name": "InlineContentDrawerTemplate_UpdateContentUsageMutation",
    "operationKind": "mutation",
    "text": "mutation InlineContentDrawerTemplate_UpdateContentUsageMutation(\n  $input: UpdateContentUsageInput!\n  $contentLabelIds: [ID!]\n) {\n  response: updateContentUsage(input: $input) {\n    node {\n      id\n      contentCoverVideoAssetUsage {\n        id\n      }\n      contentCoverVideoAssetUsagePlays\n      contentCoverVideoAssetUsageAverageCompletion\n      content {\n        id\n        type\n        label\n        systemTaskKind\n        contentLabelId\n        coverPhotoAsset {\n          id\n        }\n        coverVideoAsset {\n          id\n        }\n        organization {\n          contentLabels {\n            edges {\n              node {\n                id\n                label\n                defaultContentTypes\n                updatedAt\n              }\n            }\n          }\n          id\n        }\n      }\n      module {\n        id\n        type\n        usages {\n          edges {\n            node {\n              id\n              ...ContentModuleUtils_RefreshContentModulesFragment_pt7oe\n            }\n          }\n        }\n        children {\n          edges {\n            node {\n              id\n              ...DeleteContentUsageButtonFragment\n            }\n          }\n        }\n      }\n      ...InlineContentDrawerTemplateFragment\n      ...ContentUsageGridItemFragment\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment AdminContentLibraryItemUsages_ContentFragment on Content {\n  id\n}\n\nfragment BookmarkButtonContentFragment on Content {\n  id\n  hasViewerBookmarked\n}\n\nfragment BookmarkButtonContentUsageFragment on ContentUsage {\n  id\n  hasViewerBookmarked\n}\n\nfragment CommentUtils_useTotalCommentsCount on Content {\n  totalComments\n}\n\nfragment CommentUtils_useTotalCommentsOnUsageCount on ContentUsage {\n  totalComments\n}\n\nfragment ConnectSlackCurriculumItemBannerFragment on ContentUsage {\n  viewerHasCompleted\n}\n\nfragment ContentCommentButton_ContentFragment on Content {\n  ...CommentUtils_useTotalCommentsCount\n  hasViewerCommented\n}\n\nfragment ContentCommentButton_ContentUsageFragment on ContentUsage {\n  ...CommentUtils_useTotalCommentsOnUsageCount\n  hasViewerCommented\n}\n\nfragment ContentFooterSection_ContentFragment on Content {\n  id\n  hasViewerBookmarked\n  showComments\n  ...ContentReactionButton_ContentFragment\n  ...ContentCommentButton_ContentFragment\n  ...BookmarkButtonContentFragment\n}\n\nfragment ContentFooterSection_ContentUsageFragment on ContentUsage {\n  id\n  contentId\n  hasViewerBookmarked\n  showComments\n  ...ContentReactionButton_ContentUsageFragment\n  ...ContentCommentButton_ContentUsageFragment\n  ...BookmarkButtonContentUsageFragment\n}\n\nfragment ContentInstancesTooltipFragment on Content {\n  usages {\n    totalCount\n  }\n  ...AdminContentLibraryItemUsages_ContentFragment\n}\n\nfragment ContentModuleAdminDropdownFragment on ContentUsage {\n  id\n  entity\n  ...CreateContentModuleItemButtonFragment\n  ...UpdateContentModuleButtonFragment\n  ...DeleteContentUsageButtonFragment\n  ...ContentUsageAssociateEventsButtonFragment\n}\n\nfragment ContentModuleEventsListItem_OccurrenceFragment on Occurrence {\n  id\n  name\n  coverPhoto\n  isComplete\n  datetimeRange\n  product {\n    cover\n    name\n    id\n  }\n  event {\n    id\n    ...MemberGroupEventTagListFragment\n    ...usePermissionsFragment\n    memberGroups {\n      totalCount\n    }\n  }\n  rsvps {\n    totalCount\n  }\n  attendees {\n    totalCount\n  }\n}\n\nfragment ContentModuleEvents_ContentUsageFragment on ContentUsage {\n  occurrences {\n    totalCount\n    edges {\n      node {\n        id\n        ...ContentModuleEventsListItem_OccurrenceFragment\n      }\n    }\n  }\n}\n\nfragment ContentModuleGridItemFragment on ContentUsage {\n  id\n  entity\n  isDefaultCollectionModule\n  content {\n    id\n    type\n    children {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n  }\n  ...ContentModuleGridItemToolbarFragment\n}\n\nfragment ContentModuleGridItemToolbarFragment on ContentUsage {\n  id\n  entity\n  isDefaultCollectionModule\n  content {\n    name\n    type\n    id\n  }\n  ...CreateContentModuleItemButtonFragment\n  ...ContentModuleAdminDropdownFragment\n  ...usePermissionsFragment\n}\n\nfragment ContentModuleListItemFragment_pt7oe on ContentUsage {\n  id\n  releasedAt\n  viewerHasCompleted\n  isLocked\n  hasPrerequisites\n  content {\n    id\n    type\n    name\n    description\n    children(contentLabelIds: $contentLabelIds) {\n      totalCount\n      edges {\n        node {\n          id\n          isLocked\n          hasPrerequisites\n          content {\n            timeEstimateMinutes\n            id\n          }\n        }\n      }\n    }\n    viewerChildContentCompletions {\n      totalCount\n    }\n  }\n  occurrences {\n    totalCount\n  }\n  ...CreateContentModuleItemButtonFragment\n  ...ContentModuleReleaseCountdownFragment\n  ...ContentModuleReleaseDateFragment\n  ...ContentModuleAdminDropdownFragment\n  ...usePermissionsFragment\n  ...ContentModuleEvents_ContentUsageFragment\n  ...ContentUsageLockIconFragment\n}\n\nfragment ContentModuleNavigationSectionDividerFragment on ContentUsage {\n  id\n  entity\n  entityId\n  ordering\n  ...usePermissionsFragment\n}\n\nfragment ContentModuleNavigationSectionFragment on ContentUsage {\n  id\n  releasedAt\n  hasPrerequisites\n  isLocked\n  isDefaultCollectionModule\n  content {\n    id\n    name\n    isCurriculumModule\n    children {\n      edges {\n        node {\n          id\n          viewerHasCompleted\n          ...ContentUsageNavigationItemFragment\n        }\n      }\n    }\n  }\n  occurrences {\n    totalCount\n  }\n  ...CreateContentModuleItemButtonFragment\n  ...ContentModuleNavigationSectionDividerFragment\n  ...ContentModuleEvents_ContentUsageFragment\n  ...ContentModuleAdminDropdownFragment\n  ...ContentUsageLockIconFragment\n  ...usePermissionsFragment\n}\n\nfragment ContentModuleReleaseCountdownFragment on ContentUsage {\n  releasedAt\n}\n\nfragment ContentModuleReleaseDateFragment on ContentUsage {\n  id\n  releasedAt\n}\n\nfragment ContentModuleUtils_RefreshCollectionFragment on Collection {\n  id\n  modules {\n    totalCount\n    edges {\n      node {\n        id\n        ordering\n        ...ContentModuleGridItemFragment\n        ...ContentModuleNavigationSectionFragment\n      }\n    }\n  }\n}\n\nfragment ContentModuleUtils_RefreshContentModulesFragment_pt7oe on ContentUsage {\n  id\n  curriculum {\n    id\n    ...ContentModuleUtils_RefreshCurriculumFragment_pt7oe\n  }\n  collection {\n    id\n    ...ContentModuleUtils_RefreshCollectionFragment\n  }\n}\n\nfragment ContentModuleUtils_RefreshCurriculumFragment_pt7oe on Curriculum {\n  id\n  modules {\n    totalCount\n    edges {\n      node {\n        id\n        ordering\n        ...ContentModuleListItemFragment_pt7oe\n      }\n    }\n  }\n}\n\nfragment ContentReactionButton_ContentFragment on Content {\n  id\n  likes {\n    totalCount\n  }\n}\n\nfragment ContentReactionButton_ContentUsageFragment on ContentUsage {\n  id\n  likes {\n    totalCount\n  }\n}\n\nfragment ContentThumbnailWithDetails_ContentFragment on Content {\n  id\n  type\n  label\n  name\n  creationDatetime\n  ...ContentThumbnail_ContentFragment\n}\n\nfragment ContentThumbnailWithDetails_ContentUsageFragment on ContentUsage {\n  id\n  dueAt\n  entity\n  product {\n    name\n    id\n  }\n  module {\n    isCurriculumModule\n    isCollectionModule\n    name\n    id\n  }\n}\n\nfragment ContentThumbnail_ContentFragment on Content {\n  id\n  type\n  coverVideo\n  thumbnailUrl\n  showCoverPlayIcon\n}\n\nfragment ContentUsageAssignmentSubmitBannerFragment on ContentUsage {\n  id\n  submissionMethod\n  passPercentage\n  viewerSubmission {\n    id\n    hasPassed\n  }\n  ...ContentUsageUtils_useSubmissionDeadlineFragment\n  ...SubmitAssignmentFormFragment\n}\n\nfragment ContentUsageAssociateEventsButtonFragment on ContentUsage {\n  id\n  productId\n  organizationId\n  occurrences {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment ContentUsageGridItemFragment on ContentUsage {\n  id\n  showComments\n  hasViewerBookmarked\n  productApp {\n    customAppTitle\n    id\n  }\n  ...BookmarkButtonContentUsageFragment\n  module {\n    usages {\n      edges {\n        node {\n          id\n          productApp {\n            customAppTitle\n            id\n          }\n          collection {\n            id\n            app {\n              customAppTitle\n              id\n            }\n          }\n          curriculum {\n            id\n            product {\n              name\n              id\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  content {\n    id\n    type\n    label\n    name\n    description\n    coverPhoto\n    coverVideo\n    thumbnailUrl\n    showCoverPlayIcon\n    coverVideoAssetUsage {\n      id\n      asset {\n        id\n        ...DiscoVideoFragment\n      }\n    }\n    productId\n    ...ContentFooterSection_ContentFragment\n    ...BookmarkButtonContentFragment\n  }\n  ...DeleteContentUsageButtonFragment\n  ...ContentFooterSection_ContentUsageFragment\n  ...ContentUsageUtils_useContentUsagePathContentUsageFragment\n}\n\nfragment ContentUsageLockIconFragment on ContentUsage {\n  id\n  entity\n  content {\n    name\n    id\n  }\n  ...UpdateContentModuleButtonFragment\n  ...usePermissionsFragment\n}\n\nfragment ContentUsageMarkAsCompleteButtonFragment on ContentUsage {\n  id\n  ...useTrackContentCompletionFragment\n  viewerScormCompletion {\n    status\n    id\n  }\n  requireScormCompletion\n  confirmationModalContent {\n    ...CurriculumConfirmationModalConfirmationModalFragment\n    id\n  }\n  ...usePermissionsFragment\n}\n\nfragment ContentUsageNavigationItemFragment on ContentUsage {\n  id\n  entity\n  viewerHasCompleted\n  isLocked\n  hasPrerequisites\n  confirmationModalContent {\n    id\n  }\n  content {\n    id\n    name\n    type\n    label\n    systemTaskKind\n    showCoverPlayIcon\n    coverVideo\n    thumbnailUrl\n  }\n  product {\n    slack {\n      id\n      inviteURL\n    }\n    id\n  }\n  ...ContentUsageLockIconFragment\n  ...usePermissionsFragment\n}\n\nfragment ContentUsagePrerequisiteItemFragment on ContentUsage {\n  id\n  releasedAt\n  viewerHasCompleted\n  ...ContentThumbnailWithDetails_ContentUsageFragment\n  isLocked\n  passPercentage\n  content {\n    id\n    isCurriculumModule\n    ...ContentThumbnailWithDetails_ContentFragment\n    name\n    type\n    description\n    children {\n      totalCount\n      edges {\n        node {\n          id\n          viewerHasCompleted\n          content {\n            type\n            contentLabelId\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ContentUsageUtils_UseParentEntityContentUsageFragment on ContentUsage {\n  id\n  entity\n  module {\n    isCurriculumModule\n    isCollectionModule\n    id\n  }\n  productApp {\n    kind\n    id\n  }\n}\n\nfragment ContentUsageUtils_useContentUsagePathContentUsageFragment on ContentUsage {\n  id\n  entity\n  entityId\n  product {\n    slug\n    id\n  }\n  productApp {\n    kind\n    id\n  }\n  module {\n    usages {\n      edges {\n        node {\n          id\n          entity\n          entityId\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment ContentUsageUtils_useNavigateToNextContentUsageFragment on ContentUsage {\n  id\n  module {\n    children {\n      edges {\n        node {\n          id\n          content {\n            id\n            type\n            name\n            systemTaskKind\n            ...ContentThumbnailWithDetails_ContentFragment\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment ContentUsageUtils_useSubmissionDeadlineFragment on ContentUsage {\n  dueAt\n  viewerSubmission {\n    createdAt\n    id\n  }\n}\n\nfragment CreateCollectionModuleItemContentUsageButtonFragment on ContentUsage {\n  id\n  content {\n    id\n  }\n  productId\n}\n\nfragment CreateContentModuleItemButtonFragment on ContentUsage {\n  id\n  entity\n  ...CreateCollectionModuleItemContentUsageButtonFragment\n  ...CreateCurriculumModuleItemContentUsageButtonFragment\n}\n\nfragment CreateCurriculumModuleItemContentUsageButtonFragment on ContentUsage {\n  id\n  entity\n  entityId\n  content {\n    id\n    createCurriculumModuleItemContentUsageButtonChildren: children {\n      totalCount\n    }\n  }\n  productId\n}\n\nfragment CurriculumConfirmationModalConfirmationModalFragment on Content {\n  name\n  richEditorDescriptionContent\n  ctaText\n}\n\nfragment CurriculumDrawerFooterContentFragment on ContentUsage {\n  id\n  viewerHasCompleted\n  content {\n    type\n    systemTaskKind\n    id\n  }\n  isLocked\n  submissionMethod\n  ...usePermissionsFragment\n  ...ContentUsageMarkAsCompleteButtonFragment\n}\n\nfragment DeleteContentUsageButtonFragment on ContentUsage {\n  id\n  isLocked\n  entity\n  entityId\n  productId\n  dependents {\n    edges {\n      node {\n        id\n        content {\n          isCurriculumModule\n          id\n        }\n        ...ContentUsagePrerequisiteItemFragment\n        ...UpdateContentModuleButtonFragment\n      }\n    }\n  }\n  module {\n    isCurriculumModule\n    id\n  }\n  content {\n    type\n    label\n    isCurriculumModule\n    allChildren: children {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    id\n  }\n  productApp {\n    customAppTitle\n    id\n  }\n  ...ContentUsageUtils_useNavigateToNextContentUsageFragment\n  ...ContentUsageUtils_UseParentEntityContentUsageFragment\n}\n\nfragment DiscoEditorMentionsFragment on Content {\n  id\n  ...EditorMentionsProviderFragment\n}\n\nfragment DiscoVideoFragment on Asset {\n  id\n  url\n  name\n  muxAssetPlaybackId\n  aspectRatio\n  videoDuration\n}\n\nfragment EditorMentionsProviderFragment on Content {\n  id\n  mentions {\n    edges {\n      node {\n        id\n        user {\n          id\n          fullName\n        }\n        memberGroup {\n          id\n          name\n          kind\n          role\n        }\n        mentionedProduct {\n          id\n          name\n        }\n        mentionedContentUsage {\n          id\n          content {\n            id\n            name\n          }\n        }\n        mentionedOccurrence {\n          id\n          name\n          content {\n            name\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment InlineContentAttachmentsSectionFragment on Content {\n  attachments {\n    edges {\n      node {\n        id\n        name\n        type\n        downloadUrl\n        videoUrl\n        mediaUrl\n      }\n    }\n  }\n}\n\nfragment InlineContentCoverVideoFormFragment on Content {\n  coverVideoAsset {\n    id\n  }\n}\n\nfragment InlineContentDescriptionSectionFragment on Content {\n  id\n  richEditorDescriptionContent\n  ...DiscoEditorMentionsFragment\n}\n\nfragment InlineContentDrawerFooterFragment on ContentUsage {\n  content {\n    usages {\n      totalCount\n    }\n    ...ContentInstancesTooltipFragment\n    id\n  }\n  ...CurriculumDrawerFooterContentFragment\n  ...InlineContentDrawerSubmitButtonFragment\n}\n\nfragment InlineContentDrawerHeaderOverflowFragment on ContentUsage {\n  id\n  content {\n    name\n    label\n    id\n  }\n  ...DeleteContentUsageButtonFragment\n  ...usePermissionsFragment\n}\n\nfragment InlineContentDrawerSubmitButtonFragment on ContentUsage {\n  entity\n  content {\n    type\n    label\n    contentLabelId\n    usages {\n      totalCount\n    }\n    id\n  }\n}\n\nfragment InlineContentDrawerTemplateFragment on ContentUsage {\n  id\n  isLocked\n  hasPrerequisites\n  entity\n  entityId\n  ordering\n  dueAt\n  submissionMethod\n  submissionVisibility\n  submissionFormat {\n    text {\n      enabled\n      required\n    }\n    file {\n      enabled\n      required\n    }\n    link {\n      enabled\n      required\n    }\n  }\n  showComments\n  passPercentage\n  requireScormCompletion\n  content {\n    id\n    name\n    type\n    label\n    systemTaskKind\n    richEditorDescriptionContent\n    attachments {\n      edges {\n        node {\n          id\n          name\n          mediaUrl\n        }\n      }\n    }\n    thumbnailUrl\n    coverPhoto\n    coverVideo\n    timeEstimateMinutes\n    coverVideoAsset {\n      id\n    }\n    coverVideoDurationSeconds\n    showCoverPlayIcon\n    usages {\n      totalCount\n    }\n    contentLabelId\n    webForm {\n      id\n      currentRevision {\n        id\n        webFormId\n        questions {\n          edges {\n            node {\n              id\n              type\n              ordering\n              richEditorBody\n              isRequired\n              options {\n                id\n                label\n              }\n              answerKey {\n                correctIds\n                feedback\n              }\n            }\n          }\n        }\n      }\n    }\n    ...InlineContentHeroSectionFragment\n    ...InlineContentAttachmentsSectionFragment\n    ...InlineContentDescriptionSectionFragment\n    ...InlineContentHeroAndProperties_ContentFragment\n    ...BookmarkButtonContentFragment\n    ...DiscoEditorMentionsFragment\n  }\n  prerequisites {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  product {\n    id\n    adminCanLearnMode\n    ...LearnModeSwitchFragment\n  }\n  productApp {\n    id\n    kind\n  }\n  module {\n    name\n    usages {\n      edges {\n        node {\n          id\n          ...InlineContentDrawerTemplate_ModuleContentUsageFragment\n        }\n      }\n    }\n    id\n  }\n  contentDashboardBlock {\n    id\n  }\n  confirmationModalContent {\n    id\n    name\n    richEditorDescriptionContent\n    ctaText\n  }\n  ...QuizSubmissionEditorContentUsageFragment\n  ...InlineContentDrawerTitleFormFragment\n  ...InlineContentDrawerHeaderOverflowFragment\n  ...ContentFooterSection_ContentUsageFragment\n  ...InlineContentDrawerFooterFragment\n  ...usePermissionsFragment\n  ...useTrackContentViewFragment\n  ...QuizEditorBanner_ContentUsageFragment\n  ...ContentUsageAssignmentSubmitBannerFragment\n  ...ConnectSlackCurriculumItemBannerFragment\n  ...BookmarkButtonContentUsageFragment\n  ...ShareContentUsageButtonFragment\n}\n\nfragment InlineContentDrawerTemplate_ModuleContentUsageFragment on ContentUsage {\n  id\n  entity\n  entityId\n  releasedAt\n  isReleased\n  isLocked\n  hasPrerequisites\n  content {\n    id\n    name\n    isCurriculumModule\n    children {\n      totalCount\n    }\n  }\n}\n\nfragment InlineContentDrawerTitleFormFragment on ContentUsage {\n  id\n  content {\n    name\n    id\n  }\n  ...InlineContentDrawerSubmitButtonFragment\n}\n\nfragment InlineContentHeroAndProperties_ContentFragment on Content {\n  id\n  name\n  type\n  attachments {\n    edges {\n      node {\n        id\n        name\n        mediaUrl\n      }\n    }\n  }\n  thumbnailUrl\n  coverPhoto\n  coverVideo\n  coverVideoDurationSeconds\n  showComments\n  showCoverPlayIcon\n  ...InlineContentHeroSectionFragment\n  ...InlineContentAttachmentsSectionFragment\n  ...InlineContentHeroButtonsFragment\n}\n\nfragment InlineContentHeroButtonsFragment on Content {\n  attachments {\n    totalCount\n  }\n  coverPhoto\n  coverVideo\n  ...InlineContentAttachmentsSectionFragment\n}\n\nfragment InlineContentHeroSectionFormFragment on Content {\n  ...InlineContentCoverVideoFormFragment\n}\n\nfragment InlineContentHeroSectionFragment on Content {\n  ...InlineContentHeroSectionStaticFragment\n  ...InlineContentHeroSectionFormFragment\n}\n\nfragment InlineContentHeroSectionStaticFragment on Content {\n  id\n  coverPhoto\n  coverVideo\n  coverVideoAsset {\n    id\n  }\n  coverVideoAssetUsage {\n    id\n  }\n}\n\nfragment LearnModeSwitchFragment on Product {\n  id\n  name\n  status\n  viewerMembership {\n    id\n  }\n}\n\nfragment MemberGroupEventTagListFragment on Event {\n  id\n  product {\n    type\n    id\n  }\n  memberGroups {\n    edges {\n      node {\n        id\n        kind\n        parentMemberGroupId\n        name\n        product {\n          name\n          id\n        }\n        ...MemberGroupTagFragment\n      }\n    }\n  }\n}\n\nfragment MemberGroupTagFragment on MemberGroup {\n  id\n  name\n  kind\n  color\n  role\n  isSystem\n  product {\n    id\n    name\n  }\n}\n\nfragment QuizEditorBanner_ContentUsageFragment on ContentUsage {\n  id\n  content {\n    type\n    webForm {\n      id\n      currentRevision {\n        id\n      }\n    }\n    id\n  }\n  module {\n    isCurriculumModule\n    id\n  }\n  ...usePermissionsFragment\n}\n\nfragment QuizSubmissionEditorContentUsageFragment on ContentUsage {\n  id\n  content {\n    name\n    id\n  }\n  ...QuizSubmissionFormContentUsageFragment\n}\n\nfragment QuizSubmissionFormContentUsageFragment on ContentUsage {\n  confirmationModalContent {\n    ...CurriculumConfirmationModalConfirmationModalFragment\n    id\n  }\n}\n\nfragment ShareContentUsageButtonFragment on ContentUsage {\n  id\n  entity\n  module {\n    id\n  }\n  content {\n    label\n    id\n  }\n  ...ShareContentUsageUtils_useShareUrlFragment\n}\n\nfragment ShareContentUsageUtils_useShareUrlFragment on ContentUsage {\n  id\n  entity\n  ...ContentUsageUtils_useContentUsagePathContentUsageFragment\n}\n\nfragment SubmitAssignmentFormFieldsFragment on ContentUsage {\n  id\n  submissionVisibility\n  submissionFormat {\n    text {\n      enabled\n      required\n    }\n    file {\n      enabled\n      required\n    }\n    link {\n      enabled\n      required\n    }\n  }\n}\n\nfragment SubmitAssignmentFormFragment on ContentUsage {\n  id\n  dueAt\n  submissionVisibility\n  ...SubmitAssignmentFormFieldsFragment\n  ...ContentUsageUtils_useSubmissionDeadlineFragment\n  confirmationModalContent {\n    ...CurriculumConfirmationModalConfirmationModalFragment\n    id\n  }\n  ...usePermissionsFragment\n}\n\nfragment UpdateContentModuleButtonFragment on ContentUsage {\n  id\n  entity\n  entityId\n  content {\n    type\n    label\n    id\n  }\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n\nfragment useTrackContentCompletionFragment on ContentUsage {\n  id\n  entity\n  content {\n    type\n    label\n    id\n  }\n}\n\nfragment useTrackContentViewFragment on ContentUsage {\n  id\n}\n"
  }
};
})();

(node as any).hash = "c14481e1d24e9ef11100f80e5dca073d";

export default node;
